import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';
import { Modals } from '@/features/serviceModal/enums/Modals';

type ServiceModalSlice = RootState['serviceModal'];

export const selectServiceModalSlice = (state: RootState) => state?.serviceModal;

export const selectModalPayload = (modalName: Modals) =>
  createSelector(selectServiceModalSlice, (state: ServiceModalSlice) => state?.[modalName] || {});
